module.exports = __webpack_public_path__ + "img/hr-dead-dry-hairy-tree-01.659f3471.png";